import { Fragment, useContext } from "react";

import { useTranslation } from "react-i18next";

import CardItemValue from "components/TableDetails/components/CardItemValue";
import { TitleInfo } from "components/TableDetails/components/TitleInfo";
import { renderAvailableData } from "components/TableDetails/functions";
import AuthContext from "context/auth/authContext";
import TableContext from "context/table/tableContext";

import { CARD_ITEMS, CARDS } from "../../types";
import { DetailsData } from "../types";

const CanAdapter = () => {
    const { isAdminUser } = useContext(AuthContext);
    const { detailsData } = useContext(TableContext);

    const {
        can_adapter: {
            bootstring,
            type,
            program_number,
            software_date,
            revision,
            name
        }
    }: DetailsData = detailsData;

    const { t } = useTranslation();

    const list = [
        {
            title: CARD_ITEMS.CanBootstring,
            value: bootstring,
            isAvailable: isAdminUser
        },
        {
            title: CARD_ITEMS.Type,
            value: type,
            isAvailable: true
        },
        {
            title: CARD_ITEMS.CanProgramNumber,
            value: program_number,
            isAvailable: program_number !== null
        },
        {
            title: CARD_ITEMS.CanSoftwareDate,
            value: software_date,
            isAvailable: software_date !== null
        },
        {
            title: CARD_ITEMS.CanRevision,
            value: revision,
            isAvailable: revision !== null
        },
        {
            title: CARD_ITEMS.CanAdapterName,
            value: name,
            isAvailable: isAdminUser
        }
    ];

    return (
        <div>
            <div>
                {t(`Table##${CARDS.CanAdapter}`)}

                <TitleInfo
                    aria-label={t(`Table##${CARDS.CanAdapter}`)}
                    cardName={CARDS.CanAdapter}
                    list={list}
                />
            </div>

            <div>
                {renderAvailableData(list).map(({ title, value }) => {
                    return (
                        <Fragment key={title}>
                            <span>{t(`Table##${title}`)}:</span>
                            <CardItemValue value={value} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export { CanAdapter };
